<template>
 <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark>
                <v-toolbar-title>Competition Details</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-select required clearable :items="competitions" v-model="competition_id" item-text="name" label="Competition Name" color="red" append-icon="fa fa-arrow-down" autocomplete item-value="id">  
                  </v-select>
                  
                  <v-select required clearable v-if="competition_id != null && competition_id != null" :items="filteredCategories" v-model="category_id" item-text="name" label="Trend" color="red" append-icon="fa fa-arrow-down" autocomplete item-value="id" :key="competition_id">
                  </v-select>

                  <v-select clearable v-if="competition_id != null && category_id != null && competition_id != null && category_id != null && filteredSubCategories.length" :items="filteredSubCategories" required item-value="id" v-model="sub_category_id" item-text="name" label="Sub Category" color="red" append-icon="fa fa-arrow-down" autocomplete>
                  </v-select>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>                
                <v-btn color="success"   :disabled="isDisabled" right @click.prevent="proceed">Next</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>        
</template>
<script>
  export default {
    props : ['competitions','user'],
    data (){
      return {
        disabled : true,
        competition_id: null,
        category_id: null,
        sub_category_id: 0
      }
    },
    computed : {
      filteredCategories(){
        if (this.competition_id != null) {
          this.user.data.competition_change = false
          this.user.data.competition_change = true
          this.category_id = null
          let categories = this.competitions.filter( competition => competition.id === this.competition_id);
          if (categories.length > 0) {
            return categories[0].categories;
          } 
        } else {
          return []
        }
      },
      filteredSubCategories(){
        let result = []
        if (this.competition_id != null && this.category_id != null) {
          this.user.data.competition_change = false
          this.user.data.competition_change = true
          this.sub_category_id = null
          let subCategories = this.filteredCategories.filter(category => category.id === this.category_id);
          if (subCategories && subCategories.length > 0) {
            return subCategories[0].sub_categories;
          } else {
            this.sub_category_id = null;
          }
        }
        return result;
      },
      isDisabled(){
          if (this.competition_id != null && this.category_id != null) {
            if (this.filteredSubCategories.length) {
              if (this.sub_category_id != null) {
                this.disabled = false;
                return this.disabled;   
              }
            }else{
              this.disabled = false;
              return this.disabled;
            }
          }
          return true;
      }
    },
    methods : {
        proceed(){
            this.user.data.competition_id = this.competition_id;
            if (this.competition_id == 2) {
              this.user.data.affiliation_type = 'school';
            } else {
              this.user.data.affiliation_type = 'university';
            }
            this.user.data.category_id = this.category_id;
            this.user.data.sub_category_id = this.sub_category_id;
            this.$emit('completed',this.user);
        }
    }
  };
</script>
<style>
    
</style>


// WEBPACK FOOTER //
// src/components/Registeration/Competition.vue